<div class="table-row">
	@let r = getDataRow();
	@if (showDate()) {
		<div>{{ row().date | date: 'HH:mm' }}</div>
	}
	<div class="">{{ GlobalRecordTypeDict[row().type].name }}</div>
	<div class="ml-auto">{{ r.qty.toFixed() }}{{ r.unit }}</div>
</div>